import * as types from './mutation-types'

export const ActionDefinirEstaCadastrandoCartao = ({ commit }, estaCadastrandoCartao) => {
  const cadastrandoCartao = (estaCadastrandoCartao === 'true' || estaCadastrandoCartao === true)
  commit(types.SET_ESTA_CADASTRANDO_CARTAO, cadastrandoCartao)
}

export const ActionDefinirFormaPagamentoCliente = ({ commit, state }, estaDefinindoFormaPagamentoCliente) => {
  const novoPayload = {
    ...state.formularioFormaDePagamentoCliente,
    ...estaDefinindoFormaPagamentoCliente
  }
  commit(types.SET_FORMA_PAGAMENTO_CLIENTE, novoPayload)
}
